import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./calculatorWrapper.module.scss";

export const CalculatorWrapper = (props: PropsWithChildren): ReactElement => {
  return (
    <div className={styles["base"]}>
      <div className={styles["wrapper"]}>{props.children}</div>
    </div>
  );
};
